const ChallengeCompleteSilver = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={166}
    height={166}
    viewBox='0 0 166 166'
  >
    <defs>
      <path id='a' d='M0 164h164V0H0z' />
      <path
        id='c'
        d='M.08.052v14.229h85.367V8.64H10.703A1.802 1.802 0 0 1 8.9 6.84V.052H.08z'
      />
      <linearGradient
        id='d'
        x1='20.833%'
        x2='74.136%'
        y1='224.991%'
        y2='-94.809%'
      >
        <stop offset='0%' stopColor='#999C9E' />
        <stop offset='100%' stopColor='#B8BCC1' />
      </linearGradient>
      <path
        id='f'
        d='M.07.023v11.383H56.98V6H10.544a1.802 1.802 0 0 1-1.802-1.803V.023H.07z'
      />
      <linearGradient id='g' x1='20%' x2='74.75%' y1='199.996%' y2='-73.745%'>
        <stop offset='0%' stopColor='#999C9E' />
        <stop offset='100%' stopColor='#B8BCC1' />
      </linearGradient>
      <path id='i' d='M.127.11h5.691v19.918H.128z' />
      <linearGradient
        id='j'
        x1='138.278%'
        x2='-38.276%'
        y1='6.314%'
        y2='93.686%'
      >
        <stop offset='0%' stopColor='#999C9E' />
        <stop offset='100%' stopColor='#B8BCC1' />
      </linearGradient>
      <path
        id='l'
        d='M.07.006v31.3c0 15.708 12.748 28.457 28.456 28.457 2.16 0 4.263-.242 6.283-.698-12.688-2.862-22.175-14.21-22.175-27.759V.006H.07z'
      />
      <linearGradient id='m' x1='5.495%' x2='85.587%' y1='75.288%' y2='28.728%'>
        <stop offset='0%' stopColor='#999C9E' />
        <stop offset='100%' stopColor='#B8BCC1' />
      </linearGradient>
      <path
        id='o'
        d='M.032.034v22.764c6.315 0 11.67-4.113 13.527-9.808a14.145 14.145 0 0 1-8.12 2.547V.034H.031z'
      />
      <linearGradient
        id='p'
        x1='-31.175%'
        x2='72.947%'
        y1='81.473%'
        y2='19.598%'
      >
        <stop offset='0%' stopColor='#999C9E' />
        <stop offset='100%' stopColor='#B8BCC1' />
      </linearGradient>
      <path
        id='r'
        d='M3.684.033A3.604 3.604 0 0 0 .08 3.638V8.57c0 7.858 6.37 14.228 14.227 14.228V.033H3.684zM5.486 8.57V5.44h3.415v10.096A8.81 8.81 0 0 1 5.486 8.57z'
      />
      <linearGradient id='s' x1='129.644%' x2='7.064%' y1='81.472%' y2='4.86%'>
        <stop offset='0%' stopColor='#999C9E' />
        <stop offset='100%' stopColor='#B8BCC1' />
      </linearGradient>
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(1 1)'>
        <path
          fill='#FFF'
          d='M81.82 163.099C37.03 163.099.9 126.789.9 82 .901 37.21 37.031.901 81.82.901c44.79 0 81.279 36.31 81.279 81.099 0 44.79-36.49 81.099-81.28 81.099z'
        />
        <path
          stroke='#E3E6E8'
          strokeWidth={2}
          d='M163.099 82c0 44.79-36.49 81.099-81.28 81.099C37.03 163.099.902 126.789.902 82 .901 37.21 37.031.901 81.82.901c44.79 0 81.279 36.31 81.279 81.099z'
        />
        <mask id='b' fill='#fff'>
          <use xlinkHref='#a' />
        </mask>
        <path
          fill='#FFF'
          d='M39.368 136.109h85.367V121.88H39.368z'
          mask='url(#b)'
        />
      </g>
      <g transform='translate(40.288 122.829)'>
        <mask id='e' fill='#fff'>
          <use xlinkHref='#c' />
        </mask>
        <path
          fill='url(#d)'
          d='M.08.052v14.229h85.367V8.64H10.703A1.802 1.802 0 0 1 8.9 6.84V.052H.08z'
          mask='url(#e)'
        />
      </g>
      <path fill='#FFF' d='M54.596 122.881h56.911v-11.382H54.596z' />
      <g transform='translate(54.525 111.475)'>
        <mask id='h' fill='#fff'>
          <use xlinkHref='#f' />
        </mask>
        <path
          fill='url(#g)'
          d='M.07.023v11.383H56.98V6H10.544a1.802 1.802 0 0 1-1.802-1.803V.023H.07z'
          mask='url(#h)'
        />
      </g>
      <path fill='#FFF' d='M77.36 111.499h11.382v-19.92H77.36z' />
      <g transform='translate(77.233 91.47)'>
        <mask id='k' fill='#fff'>
          <use xlinkHref='#i' />
        </mask>
        <path fill='url(#j)' d='M.127 20.028h5.691V.11H.128z' mask='url(#k)' />
      </g>
      <path
        fill='#FFF'
        d='M100.77 31.823h10.737v31.301c0 7.854-3.187 14.968-8.337 20.118-5.151 5.15-12.265 8.338-20.119 8.338-15.707 0-28.456-12.748-28.456-28.456V31.823h33.49'
      />
      <g transform='translate(54.525 31.818)'>
        <mask id='n' fill='#fff'>
          <use xlinkHref='#l' />
        </mask>
        <path
          fill='url(#m)'
          d='M.07.006v31.3c0 15.708 12.748 28.457 28.456 28.457 2.16 0 4.263-.242 6.283-.698-12.688-2.862-22.175-14.21-22.175-27.759V.006H.07z'
          mask='url(#n)'
        />
      </g>
      <path
        fill='#FFF'
        d='M122.13 43.205h-10.623v22.764c7.858 0 14.228-6.37 14.228-14.227v-4.933a3.604 3.604 0 0 0-3.605-3.604m-1.802 5.406v3.13a8.81 8.81 0 0 1-3.414 6.966V48.611h3.414'
      />
      <g transform='translate(111.475 43.171)'>
        <mask id='q' fill='#fff'>
          <use xlinkHref='#o' />
        </mask>
        <path
          fill='url(#p)'
          d='M.032.034v22.764c6.315 0 11.67-4.113 13.527-9.808a14.145 14.145 0 0 1-8.12 2.547V.034H.031z'
          mask='url(#q)'
        />
      </g>
      <g transform='translate(40.288 43.171)'>
        <mask id='t' fill='#fff'>
          <use xlinkHref='#r' />
        </mask>
        <path
          fill='url(#s)'
          d='M3.684.033A3.604 3.604 0 0 0 .08 3.638V8.57c0 7.858 6.37 14.228 14.227 14.228V.033H3.684zM5.486 8.57V5.44h3.415v10.096A8.81 8.81 0 0 1 5.486 8.57z'
          mask='url(#t)'
        />
      </g>
      <g
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
      >
        <path d='M40.368 137.109h85.367V122.88H40.368z' />
        <path d='M54.596 122.881h56.911v-11.382H54.596zM77.36 111.499h11.382v-19.92H77.36z' />
        <path d='M88.085 31.823h23.422v31.301c0 7.854-3.187 14.968-8.338 20.118-5.15 5.15-12.264 8.338-20.118 8.338-15.707 0-28.455-12.748-28.455-28.456V31.823h33.489M122.13 43.205h-10.623v22.764c7.858 0 14.228-6.37 14.228-14.227v-4.933a3.604 3.604 0 0 0-3.605-3.604zm-1.802 5.406v3.13a8.81 8.81 0 0 1-3.414 6.966V48.611h3.414zM43.972 43.205a3.604 3.604 0 0 0-3.604 3.604v4.933c0 7.857 6.37 14.227 14.227 14.227V43.205H43.972zm1.802 5.406h3.415v10.096a8.81 8.81 0 0 1-3.415-6.965v-3.13z' />
      </g>
    </g>
  </svg>
);

export default ChallengeCompleteSilver;
